import { PropsWithChildren } from 'react';

export default function Container(props: PropsWithChildren) {
  return (
    <div className="container mx-auto px-4">{props.children}</div>
  );
}
